var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-unit-progress",
    },
    [
      _vm.userIsTeacher
        ? _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$gettext(
                    "Die Fortschrittsanzeige bezieht sich auf den Anteil der Teilnehmenden, die eine Seite aufgerufen haben."
                  )
                ) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "nav",
        {
          staticClass: "cw-unit-progress-breadcrumb",
          attrs: {
            "aria-label": "Breadcrumb",
          },
        },
        [
          _vm.parent
            ? _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    title: _vm.$gettext("Hauptseite"),
                  },
                  on: {
                    click: _vm.visitRoot,
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "home",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.parent && _vm.parent.id !== _vm.rootId
            ? _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    title: _vm.parent.name,
                  },
                  on: {
                    click: function click($event) {
                      return _vm.selectChapter(_vm.parent.id)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            | " + _vm._s(_vm.parent.name) + "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.selected
        ? _c(
            "div",
            {
              staticClass: "cw-unit-progress-chapter",
            },
            [
              _c("h1", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.chapterUrl,
                      title: _vm.$gettextInterpolate("%{ pageTitle } öffnen", {
                        pageTitle: _vm.selected.name,
                      }),
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.selected.name) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("courseware-progress-circle", {
                attrs: {
                  title:
                    _vm.selected.id === _vm.rootId
                      ? _vm.$gettext("Gesamtes Lernmaterial")
                      : _vm.$gettext(
                          "diese Seite inkl. darunter liegender Seiten"
                        ),
                  value: parseInt(_vm.selected.progress.cumulative),
                },
              }),
              _vm._v(" "),
              _c("courseware-progress-circle", {
                staticClass: "cw-unit-progress-current",
                attrs: {
                  title: _vm.$gettext("diese Seite"),
                  value: parseInt(_vm.selected.progress.self),
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.children.length > 0
        ? _c(
            "div",
            {
              staticClass: "cw-unit-progress-subchapter-list",
            },
            _vm._l(_vm.children, function (chapter) {
              return _c("courseware-unit-progress-item", {
                key: chapter.id,
                attrs: {
                  name: chapter.name,
                  value: chapter.progress.cumulative,
                  chapterId: chapter.id,
                },
                on: {
                  selectChapter: _vm.selectChapter,
                },
              })
            }),
            1
          )
        : _c(
            "div",
            {
              staticClass: "cw-unit-empty-info",
            },
            [
              _c("courseware-companion-box", {
                attrs: {
                  mood: "sad",
                  msgCompanion: _vm.$gettext(
                    "Diese Seite enthält keine darunter liegenden Seiten."
                  ),
                },
              }),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }